import { render, staticRenderFns } from "./heart-icon.vue?vue&type=template&id=8373cb5e&functional=true&"
import script from "./heart-icon.vue?vue&type=script&lang=js&"
export * from "./heart-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports